import userManager from "@amsom-habitat/user-manager";
import authAPI from "@/services/authAPI";

let unwatchTokenCallback = null

const state = {
    dateDeb: (new Date((new Date()).getFullYear()-1,(new Date()).getMonth(),1)).getTime() / 1000
};

const getters = {
    jwt: () => authAPI.storeToken.token ?? userManager.getToken(),
    
    // Validité de la SESSION uniquement (expRefresh) : les droits sont une question distincte,
    // traitée par getRoles/isGranted. Les mêler ici faisait passer un utilisateur sans rôle
    // pour un utilisateur déconnecté.
    isValid: (state, getters) => {
        if(!getters.jwt)
            return false

        try{
            let data = getters.getDecodedToken
            if (data && data.expRefresh > Math.floor(Date.now() / 1000))
                return true;
            else
                return false;
        }
        catch(e){
            return false;
        }
    },
    
    isConnected: (state, getters) => !!getters.jwt,
    
    getConfig: () => JSON.parse(window.localStorage.getItem("config")),
    
    getDecodedToken: (state, getters) => userManager.getDecodedToken(getters.jwt),
    
    getRoles: (state, getters) => userManager.getRoles(getters.jwt),
    
    isAdmin: (state, getters) => getters.getRoles.includes('ROLE_ADMIN'),
    
    isGardien: (state, getters) => getters.getRoles.includes('ROLE_GARDIEN'),
    
    canBillBadge: (state, getters) => getters.getRoles.includes('ROLE_FACTURATION_BADGE'),
    
    getPrenomNOM: (state, getters) => {
        const decoded = getters.getDecodedToken;
        return decoded.prenom + " " + decoded.nom;
    },
    
    getCodeTiers: (state, getters) => {
        try {
            return getters.getDecodedToken.extras.TIER.TICOD;
        } catch (e) {
            if (process.env.VUE_APP_DEBUG_ENABLED === "true") console.log(e)
        }
        return null;
    },
    
    getCodePec: (state, getters) => {
        let codePec = null
        try {
            codePec = getters.getDecodedToken.extras.PEC
        } catch (e) {
            if (process.env.VUE_APP_DEBUG_ENABLED === "true") console.log(e)
        }
        return codePec
    },
    
    canBeAffected: (state, getters) => !getters.isGardien,
    
    getDateDeb: state => state.dateDeb,
    
    getOptions: () => {
        if (!window.localStorage.getItem("options-suiviSollicitation")) {
            // Create default options if they don't exist
            let options = { maskedNumber: true };
            window.localStorage.setItem("options-suiviSollicitation", JSON.stringify(options))
        }
        return JSON.parse(window.localStorage.getItem("options-suiviSollicitation"));
    },

    isTokenValid: (state, getters) => userManager.isTokenValid(getters.jwt),

    tokenTimeRemaining: (state, getters) => userManager.getTokenTimeRemaining(getters.jwt)
};

const mutations = {
    SET_DATE_DEB(state, dateDeb) {
        state.dateDeb = dateDeb;
    }
};

const actions = {
    setConfig(context, config) {
        window.localStorage.setItem("config", JSON.stringify(config))
    },
    
    setOption({ getters }, { optionName, optionValue }) {
        let options = getters.getOptions;
        options[optionName] = optionValue;
        window.localStorage.setItem("options-suiviSollicitation", JSON.stringify(options))
    },
    
    createUserOptions() {
        let options = { maskedNumber: true };
        window.localStorage.setItem("options-suiviSollicitation", JSON.stringify(options))
    },
    
    setMaskedCall({ dispatch }, value) {
        dispatch('setOption', { optionName: 'maskedNumber', optionValue: value })
    },
    
    setDateDeb({ commit }, dateDeb) {
        commit('SET_DATE_DEB', dateDeb);
    },

    initTokenSync() {
        if (unwatchTokenCallback) return

        unwatchTokenCallback = userManager.watchToken((newToken) => {
            if (newToken !== authAPI.storeToken.token) {
                authAPI.storeToken.token = newToken
            }
        })
    },

    stopTokenSync() {
        if (unwatchTokenCallback) {
            unwatchTokenCallback()
            unwatchTokenCallback = null
        }
    },

    logout() {
        authAPI.storeToken.token = null
        userManager.logout()
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
